// Bloqué: true / false
const statutsUser = [
  { value: false, label: "Actif" },
  { value: true, label: "Inactif" },
];

export default statutsUser;
